import {
  black,
  darkBlue,
  grey,
  boxGrey,
  red,
  white,
} from "../constants/ColourConstants";

const baseTextStyle = {
  fontSize: 14,
  fontFamily: "Arial",
  textAlign: "center",
  fontWeight: "bold",
  color: darkBlue,
};

const baseAlert = {
  p: 1.5,
  textAlign: "left",
  height: "auto",
  width: "100%",
  "& .MuiAlert-message": { p: 0 },
};

export const styles = {
  typographyBody: {
    ...baseTextStyle,
    color: grey,
    fontWeight: 500,
  },
  leftAlignedTypographyBody: {
    ...baseTextStyle,
    color: black,
    fontWeight: 400,
    textAlign: "left",
  },
  typographyAccordionTitle: {
    ...baseTextStyle,
    fontSize: 18,
  },
  typographyAccordion: {
    ...baseTextStyle,
    color: grey,
    fontWeight: 500,
    textAlign: "left",
    px: "5%",
    pt: 0,
  },
  typographyTitle: {
    ...baseTextStyle,
    fontSize: 20,
  },
  typographySubtitle: {
    ...baseTextStyle,
    fontSize: 18,
    color: black,
  },
  leftAlignedSelect: { "& .MuiSelect-select": { textAlign: "left" } },
  typographySubtitleGrey: {
    ...baseTextStyle,
    fontSize: 18,
    color: grey,
    textAlign: "left",
  },
  typographyError: {
    ...baseTextStyle,
    color: red,
    fontWeight: 500,
  },
  centeredStack: {
    width: "100%",
    justifyContent: "center",
    alignItems: "flex-end",
    flexWrap: "wrap",
  },
  patientStack: {
    py: 2,
    background: boxGrey,
    borderRadius: 2,
    gap: 2,
    width: "100%",
  },
  phoneStyle: { color: "inherit", textDecoration: "underline" },
  homeButtons: {
    width: "100%",
    maxWidth: "300px",
    fontWeight: "bold",
  },
  footerText: { textAlign: "center", color: white, fontSize: "14px" },
  alertBooking: { ...baseAlert },
  alertHome: { ...baseAlert, mx: 2 },
  alertPatient: { ...baseAlert, height: { xs: "auto", sm: "100px" } },
  noPatientsBox: {
    width: "100%",
    maxWidth: 540,
    border: "1px dashed #cbd5e1",
    borderRadius: 2,
    p: { xs: 3, sm: 4 },
    textAlign: "center",
    boxShadow: "0 12px 45px rgba(15, 23, 42, 0.08)",
  },
  iconBox: {
    width: 72,
    height: 72,
    borderRadius: "50%",
    background:
      "linear-gradient(135deg, rgba(66, 132, 244, 0.15), rgba(66, 132, 244, 0.05))",
    display: "grid",
    placeItems: "center",
  },
  icon: {
    color: darkBlue,
    mr: 1,
  },
  buttonStack: {
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
};
